/** Y8 AFP Ads SDK — locked integration constants (see docs/y8.md). */

export const Y8_APP_ID = import.meta.env.VITE_Y8_APP_ID || "6a4766fa115093efea3c2f2c";
export const Y8_GAME_ID = "276003";
export const Y8_LEADERBOARD_TABLE = import.meta.env.VITE_Y8_LEADERBOARD_TABLE || "Leaderboard";
export const Y8_LEADERBOARD_TOP_SIZE = 10;

/** Y8 online-save keys (portal) — values are encoded blobs from core/storage.js. */
export const Y8_CLOUD_KEY_PROGRESS = "progress";
export const Y8_CLOUD_KEY_BEST_SCORE = "best_score";
export const Y8_CLOUD_KEY_ECONOMY = "economy";

/** Official game page for isBlacklisted() gate (game id 276003). */
export const Y8_OFFICIAL_GAME_URL = "https://www.y8.com/games/catch_n_merge";

export const Y8_SDK_SCRIPT_URL = "https://cdn.y8.com/minimal-sdk/2-0/y8.min.js";
